import { Link, useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/Store";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (user === null) navigate("/auth?next=/wishlist");
    if (user) api.get("/wishlist").then((r) => setProducts(r.data.products)).catch(() => setProducts([]));
  }, [user, navigate]);

  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-28 md:pt-36 pb-24" data-testid="wishlist-page">
      <p className="text-xs uppercase tracking-[0.25em] text-brand-blue font-semibold">Saved for later</p>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-3 flex items-center gap-4">
        Your wishlist <Heart className="h-8 w-8 fill-rose-500 text-rose-500" />
      </h1>
      {products === null ? (
        <p className="mt-10 text-brand-ink/40">Loading...</p>
      ) : products.length === 0 ? (
        <div className="text-center py-24" data-testid="wishlist-empty">
          <p className="font-display text-2xl text-brand-ink/50">Nothing saved yet</p>
          <p className="text-sm text-brand-ink/40 mt-2">Tap the heart on any product to keep it here.</p>
          <Link to="/shop" className="inline-block mt-6 rounded-full brand-gradient-bg text-white px-8 py-3.5 text-sm font-semibold" data-testid="wishlist-shop-link">
            Browse the collection
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-12" data-testid="wishlist-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
